import request from '@/utils/request'

// 管理员相关API
export const adminApi = {
  // 订单相关
  getOrders: (params) => request.get('/admin/orders', { params }),
  getOrderDetail: (id) => request.get(`/admin/orders/${id}`),
  updateOrderStatus: (data) => request.put(`/admin/orders/${data.id}/status`, data),
  settleOrder: (data) => request.post('/admin/orders/settle', data),
  getLogisticsInfo: (id) => request.get(`/admin/orders/${id}/logistics`),
  
  // 测试结果相关
  uploadTestResult: (data) => request.post('/admin/orders/test-result', data),
  getTestResult: (id) => request.get(`/admin/orders/${id}/test-result`),
  
  // 争议相关
  submitDispute: (data) => request.post('/admin/orders/dispute', data),
  getDisputeInfo: (id) => request.get(`/admin/orders/${id}/dispute`),
  
  // 转寄相关
  submitForward: (data) => request.post('/admin/orders/forward', data),
  getForwardInfo: (id) => request.get(`/admin/orders/${id}/forward`),
  
  // 回寄相关
  submitReturn: (data) => request.post('/admin/orders/return', data),
  getReturnInfo: (id) => request.get(`/admin/orders/${id}/return`)
}

// 用户相关API
export const userApi = {
  // 登录相关
  login: (data) => request.post('/user/login', data),
  logout: () => request.post('/user/logout'),
  
  // 订单相关
  createOrder: (data) => request.post('/user/orders', data),
  getOrders: (params) => request.get('/user/orders', { params }),
  getOrderDetail: (id) => request.get(`/user/orders/${id}`),
  
  // 个人信息相关
  getProfile: () => request.get('/user/profile'),
  updateProfile: (data) => request.put('/user/profile', data)
} 